import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormField } from '@app/shared/models/field.interface';
import { BaseControl } from '@components/form-controls/base-control';
import { CrossFieldErrorMatcher } from '@components/form-controls/form-control-errors';

@Component({
  selector: 'vfs-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputPasswordComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class InputPasswordComponent extends BaseControl {
  @Input() field: FormField;
  @Input() readonly: boolean;
  @Input() maxLength = 255;
  @Input() width = '220px';
  @Input() error: string;
  @Input() autocomplete = 'off';
  @Input() autofocus = false;
  @Input() matchError = false;
  @Input() disabled: boolean;

  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean;

  @Output() change = new EventEmitter();

  viewPassword = false;
  errorMatcher = new CrossFieldErrorMatcher();

  showPassword() {
    this.viewPassword = !this.viewPassword;
  }
}
